import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { RevisionAssignToSelfPathParameters } from 'api/actions/revision-assign-to-self/revision-assign-to-self-path-parameters';
import { RevisionAssignToSelfResponse } from 'api/actions/revision-assign-to-self/revision-assign-to-self-response';

type RevisionAssignToSelfQueryParameters = Record<string, any>;

/**
 * The path of the RevisionAssignToSelf action.
 */
export const revisionAssignToSelfActionPath = new SweetPath<keyof RevisionAssignToSelfPathParameters>(
  '/api/revision/assign-to-self/{revisionId}',
  { path: '{param}' }
);

/**
 * Creates a contextualized RevisionAssignToSelf actions.
 */
export default function createRevisionAssignToSelfAction(axios: AxiosInstance) {
  return function revisionAssignToSelfAction({
    headers = {},
    parameters,
    query = {},
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: RevisionAssignToSelfPathParameters;
    query?: RevisionAssignToSelfQueryParameters;
  }) {
    const path = revisionAssignToSelfActionPath.insert(parameters);

    return axios.request<RevisionAssignToSelfResponse, RevisionAssignToSelfResponse>({
      method: 'post',
      url: path,
      params: query,

      headers,
    });
  };
}
